import React, { useEffect, useRef } from "react";
import emptyImage from "../images/empty.jpg";
import tiger0 from "../images/tiger0.png";
import "./mention-picker.css";

function profileSrc(photo) {
  if (!photo) return emptyImage;
  return `${process.env.REACT_APP_IMAGES_DATA_RESOURCES_URL}/${photo}`;
}

function HighlightMatch({ name, query }) {
  const needle = (query || "").trim();
  if (!needle) return name;

  const index = name.toLowerCase().indexOf(needle.toLowerCase());
  if (index === -1) return name;

  return (
    <>
      {name.slice(0, index)}
      <mark>{name.slice(index, index + needle.length)}</mark>
      {name.slice(index + needle.length)}
    </>
  );
}

function MentionAvatar({ option }) {
  if (option.kind === "all") {
    return (
      <span className="mention-picker__badge" aria-hidden="true">
        <i className="fa fa-users" />
      </span>
    );
  }

  if (option.kind === "ai") {
    return (
      <img
        src={tiger0}
        alt=""
        className="mention-picker__avatar mention-picker__avatar--ai"
      />
    );
  }

  if (option.kind === "ai-command") {
    return (
      <span className="mention-picker__badge mention-picker__badge--command" aria-hidden="true">
        <i className="fa fa-bolt" />
      </span>
    );
  }

  return (
    <span className="mention-picker__avatar-wrap">
      <img
        src={profileSrc(option.profilePhoto)}
        alt=""
        className="mention-picker__avatar"
      />
      {option.isOnline ? <span className="mention-picker__online" /> : null}
    </span>
  );
}

export function MentionPicker({
  query,
  options,
  activeIndex,
  onActiveIndexChange,
  onSelect,
  listId = "mention-picker-list",
}) {
  const listRef = useRef(null);

  useEffect(() => {
    const selected = listRef.current?.querySelector('[aria-selected="true"]');
    if (typeof selected?.scrollIntoView === "function") {
      selected.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndex, options]);

  let previousPinned = null;

  return (
    <div className="mention-picker">
      {options.length === 0 ? (
        <p className="mention-picker__empty">
          No one matches “{query.trim()}”
        </p>
      ) : (
        <ul
          className="mention-picker__list"
          id={listId}
          role="listbox"
          ref={listRef}
        >
          {options.map((option, index) => {
            const showLabel =
              previousPinned === null || previousPinned !== option.pinned;
            previousPinned = option.pinned;
            const selected = index === activeIndex;

            return (
              <React.Fragment key={`${option.kind}-${option.id}`}>
                {showLabel ? (
                  <li className="mention-picker__label" role="presentation">
                    {option.pinned ? "Suggestions" : "People"}
                  </li>
                ) : null}
                <li
                  id={`${listId}-option-${index}`}
                  role="option"
                  aria-selected={selected}
                  className={`mention-picker__item${selected ? " is-active" : ""}`}
                  onMouseEnter={() => onActiveIndexChange(index)}
                  onMouseDown={(event) => event.preventDefault()}
                  onClick={() => onSelect(option)}
                >
                  <MentionAvatar option={option} />
                  <span className="mention-picker__copy">
                    <span className="mention-picker__name">
                      <HighlightMatch name={option.name} query={query} />
                    </span>
                    {option.subtitle ? (
                      <span className="mention-picker__subtitle">
                        {option.subtitle}
                      </span>
                    ) : null}
                  </span>
                </li>
              </React.Fragment>
            );
          })}
        </ul>
      )}
      <p className="mention-picker__hint">↑↓ move · Enter mention · Esc close</p>
    </div>
  );
}
